import React from 'react';
import AppStatusChip from '../buttons/AppStatusChip';

/**
 * Card identità per il rail sinistro delle pagine di dettaglio (hero profilo +
 * coppie chiave/valore). Coerente col mockup mbility-gestionale (.profile-hero / .kv).
 *
 * Props:
 * - avatar: stringa (iniziali) o nodo
 * - name:   titolo principale
 * - meta:   riga secondaria (muted)
 * - status: nodo (es. <AppStatusChip/>) sotto il nome
 * - facts:  array { label, value } → elenco kv
 * - chips:  array { label, variant, icon } → riga di chip (es. flag/caratteristiche)
 */
export default function ProfileCard({ avatar, name, meta, status, facts = [], chips = [] }) {
  return (
    <div className="list-card">
      <div className="card-section">
        <div className="profile-hero">
          <div className="profile-hero__avatar" aria-hidden="true">
            {avatar}
          </div>
          <div style={{ minWidth: 0 }}>
            <div className="profile-hero__name">{name}</div>
            {meta && <div className="profile-hero__meta">{meta}</div>}
            {status}
          </div>
        </div>
        {facts.length > 0 && (
          <div className="kv-list">
            {facts.map((f, i) => (
              <div className="kv" key={i}>
                <span className="k">{f.label}</span>
                <span className="v">{f.value ?? '—'}</span>
              </div>
            ))}
          </div>
        )}
        {chips.length > 0 && (
          <div className="profile-chips">
            {chips.map((c, i) => (
              <AppStatusChip
                key={i}
                variant={c.variant || 'neutral'}
                icon={c.icon}
                label={c.label}
                fullCell={false}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
